/*
 * Reusable animated text-highlight system.
 *
 * Measures the rendered `.gsafe-highlight__text` box for styles that need
 * to actually fit the word (circle, marker, solid) and sizes/positions
 * their SVG/fill element to match — rather than a fixed-size shape that
 * gets stretched. Straight/wavy underline styles are pure CSS/SVG at
 * 100% width and don't need this.
 *
 * The draw-in animation itself is driven entirely by CSS reacting to the
 * theme's existing AOS scroll-reveal (`data-aos` -> `.aos-animate`), the
 * same system snippets/image-element.liquid already uses — this file only
 * handles sizing, not the reveal trigger.
 */
(function () {
  var SIZED_STYLES = ['circle', 'marker', 'solid'];

  function measure(el) {
    var styleName = el.dataset.highlight;
    if (SIZED_STYLES.indexOf(styleName) === -1) return;

    var textEl = el.querySelector('.gsafe-highlight__text');
    if (!textEl) return;

    var w = textEl.offsetWidth;
    var h = textEl.offsetHeight;
    if (!w || !h) return;

    if (styleName === 'circle') {
      var svg = el.querySelector('.gsafe-highlight__svg--circle');
      if (!svg) return;
      var circlePadX = w * 0.14;
      var circlePadY = h * 0.34;
      svg.style.width = (w + circlePadX * 2) + 'px';
      svg.style.height = (h + circlePadY * 2) + 'px';
      svg.style.left = -circlePadX + 'px';
      svg.style.top = -circlePadY + 'px';
    } else {
      var fill = el.querySelector('.gsafe-highlight__fill');
      if (!fill) return;
      var padXRatio = styleName === 'marker' ? 0.06 : 0.08;
      var padYRatio = styleName === 'marker' ? 0.12 : 0.14;
      var padX = w * padXRatio;
      var padY = h * padYRatio;
      fill.style.width = (w + padX * 2) + 'px';
      fill.style.height = (h + padY * 2) + 'px';
      fill.style.left = -padX + 'px';
      fill.style.top = -padY + 'px';
    }
  }

  function init() {
    var els = document.querySelectorAll('.gsafe-highlight[data-highlight]');

    els.forEach(function (el) {
      measure(el);

      if (window.ResizeObserver && !el._gsafeHighlightObserved) {
        el._gsafeHighlightObserved = true;
        var textEl = el.querySelector('.gsafe-highlight__text');
        if (textEl) {
          var ro = new ResizeObserver(function () {
            measure(el);
          });
          ro.observe(textEl);
        }
      }
    });

    // New elements from a theme-editor section re-render aren't picked up
    // by AOS automatically (disableMutationObserver: true in theme.js) —
    // same reason other custom sections in this theme call this after
    // injecting content.
    if (window.AOS) {
      window.AOS.refreshHard();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Web fonts (e.g. Market Pro) can swap in after the first measurement
  // and change the text's rendered width — re-measure once they're ready.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  }

  document.addEventListener('shopify:section:load', init);
})();
